import type { MfaErrorResponse } from './types';

export function isMfaError(
  response: MfaErrorResponse | unknown
): response is MfaErrorResponse {
  return (
    typeof response === 'object' && response !== null && 'code' in response
  );
}
